import { useEffect, useRef, useState } from "react";

import { Card, CardActionArea, CardMedia, CardContent, Typography, Container, Grid, CardActions, Button, Grow } from "@mui/material"

import { useNavigate } from "react-router";

import { Header } from "../../components/Header";
import { CardEmpty } from "../../components/CardEmpty";
import { CardListaAcuerdos } from "../../components/CardListaAcuerdos";

import { ObtenerUnidades } from "../../connections/catalogos/UnidadConnection";

import { UnidadProps } from "../../interfaces/catalogos/UnidadInterface";

import { DialogAcceso } from "../../dialogs/DialogAcceso";

export const HomePage = () => {

    const navigate = useNavigate();
    
    const timeoutRef = useRef<number | null>( null );

    const [unidades, setUnidades] = useState<UnidadProps[]>( [] );

    const [loading, setLoading] = useState( true );

    const [open, setOpen] = useState( true );

    const audioRef = useRef<HTMLAudioElement>(new Audio( process.env.PUBLIC_URL + "/assets/click.wav" ));
    
    const sound = () => {

        audioRef.current.pause();
        audioRef.current.currentTime = 0;
        audioRef.current.play();

    }

    const goTo = ( path: string ) => {

        if ( audioRef.current ) {

            audioRef.current.play();
            navigate( path );
            
        }

    };

    const resetTimer = () => {

        timeoutRef.current = window.setTimeout( () => {

            if ( timeoutRef.current ) {
                window.clearTimeout( timeoutRef.current );
                
                setOpen( true );
            }

        }, 6000);

    }

    const onPauseTimer = () => {

        if( timeoutRef.current ){

            window.clearTimeout( timeoutRef.current );                
            setOpen( false );

        }

    }

    useEffect(() => {

        async function obtener() {

            setLoading(true);

            await ObtenerUnidades().then(resp => {

                setUnidades(resp);
                setLoading(false);

            });

        }

        obtener();

    }, []) 

    return (

        <>

            <Header />

            <Container maxWidth='xl' sx={{ pt: 1, pb: 4 }}>

                <Grid container spacing={3} alignItems={'center'}>

                    <Grid size={12}>

                       <CardListaAcuerdos handleSound={ sound } onPause={ onPauseTimer } onReset={ () => setOpen( true ) } />

                    </Grid>

                    {
                        loading
                        ?
                            <>

                                <CardEmpty />

                                <CardEmpty />

                                <CardEmpty />

                                <CardEmpty />

                            </>
                        :
                            <>

                                {
                                    unidades
                                    .map(({ idUnidad, descripcion, imagen }, index) => (

                                        <Grid key={index} size={{ xs: 12, sm: 6, lg: 4, xl: 3 }}>

                                            <Grow
                                                in={true}
                                                style={{ transformOrigin: '0 0 0' }}
                                                {...(true ? { timeout: 1000 } : {})}
                                            >

                                                <Card>

                                                    <CardActionArea onClick={ () => goTo( `/servicios/${idUnidad}` ) }>

                                                        <CardMedia
                                                            component="img"
                                                            height="240"
                                                            image={
                                                                imagen
                                                                ?
                                                                    imagen
                                                                :
                                                                    process.env.PUBLIC_URL + "/assets/sin-imagen.png"
                                                            }
                                                            alt={"image" + index}
                                                            sx={{ padding: "1em 1em 0 1em", objectFit: "contain" }}
                                                        />

                                                        <CardContent sx={{ height: 50 }}>

                                                            <Typography gutterBottom fontSize={16} fontWeight={'500'} variant="body1" component="div">
                                                                {descripcion}
                                                            </Typography>

                                                        </CardContent>

                                                    </CardActionArea>

                                                    <CardActions sx={{ textAlign: 'end' }}>

                                                        <Button
                                                            fullWidth
                                                            color="primary"
                                                            onClick={ () => goTo(`/servicios/${ idUnidad }`) }
                                                        >
                                                            Seleccionar opción
                                                        </Button>


                                                    </CardActions>

                                                </Card>

                                            </Grow>

                                        </Grid>

                                    ))
                                }

                            </>
                    }

                </Grid>

            </Container>

            <DialogAcceso 
                open={ open }
                onClose={ () => setOpen( false ) }
                onReset={ resetTimer }
            />

        </>

    )
}
